import apiClient from './apiClient';

// La importación anual hace 12 scrapes paralelos en el backend (~60-90 s).
// El resto de las llamadas son consultas directas a la BD (rápidas).
const TIMEOUT_IMPORTACION_MS = 150_000; // 2.5 min

const diasInhabilesJudicialesService = {

    obtenerTodos: () =>
        apiClient.get('/datos-maestros/dias-inhabiles-judiciales'),

    obtenerPorAnio: (anio) =>
        apiClient.get(`/datos-maestros/dias-inhabiles-judiciales/anio/${anio}`),

    obtenerEstadoSync: () =>
        apiClient.get('/datos-maestros/dias-inhabiles-judiciales/estado-sync'),

    importarAnio: (anio, jurisdiccion = 'Córdoba') =>
        apiClient.post(
            `/datos-maestros/dias-inhabiles-judiciales/importar/${anio}`,
            null,
            { params: { jurisdiccion }, timeout: TIMEOUT_IMPORTACION_MS }
        ),

    sincronizarAhora: () =>
        apiClient.post('/datos-maestros/dias-inhabiles-judiciales/sincronizar-ahora', null, {
            timeout: 60_000,
        }),

    eliminar: (id) =>
        apiClient.delete(`/datos-maestros/dias-inhabiles-judiciales/${id}`),

    eliminarPermanente: (id) =>
        apiClient.delete(`/datos-maestros/dias-inhabiles-judiciales/${id}/permanente`),
};

export default diasInhabilesJudicialesService;
